
export interface VisitorTermsInfo {
    termsInfoSeq:number,
    visitorInfoSeq?:number,
    agreeFlag:boolean
}

export interface TermsInfoDTO {
    termsInfoSeq:number,
    boardInfoSeq:number,
    title:string,
    contents:string,
    requiredFlag:boolean;
}
export const createTermsInfoDTO : TermsInfoDTO = {
    termsInfoSeq:null,
    boardInfoSeq:null,
    title:'',
    contents:'',
    requiredFlag:false
}